import { logger } from './logger';
import type { Target } from '@harnessio/ff-nodejs-server-sdk';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FEATURE_FLAGS, FeatureFlagService, TARGETS, FLAG_TYPE } from '@marriott/mi-feature-flag-utils';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

export const getHarnessFeatureFlags = () => {
  const { harnessLogger, log } = logger()('Harness Feature Flags');
  try {
    const featureFlagApiKey = process.env['HARNESS_API_KEY_SERVER'] || '';

    if (featureFlagApiKey) {
      const featureFlagService = new FeatureFlagService(featureFlagApiKey, {
        enableStream: false,
        pollInterval: 1000 * 60 * 5, // 5 Mins Polling Interval
        logger: harnessLogger,
      });
      const target = TARGETS.APP.BOOK_RENDERER;
      return { featureFlagService, target };
    } else {
      log.error(`'HARNESS_API_KEY_SERVER' is not defined`);
      return {};
    }
  } catch (error) {
    log.error(`Error fetching feature flags: ${error}`);
    return {};
  }
};

interface Config {
  isACRS: boolean;
  isDTT: boolean;
}

export type HarnessConfigMap = {
  [key: string]: Config;
};

export const fetchFlags = async (flags: FEATURE_FLAGS[], options: { target?: Target; enableStream?: boolean }) => {
  const featureFlagToken = process.env['HARNESS_API_KEY_SERVER'];

  const featureFlagService = new FeatureFlagService(featureFlagToken || '', options);

  console.log('----------->', featureFlagService);

  const allFlags = await featureFlagService.getFlags(flags, options);

  return allFlags;
};

export const useFeatureFlag = (flagName: string) => {
  const featureFlags = useClientEnvVarsStore(state => state?.envVarsObject?.['featureFlags']) as unknown as Record<
    string,
    FLAG_TYPE
  >;
  return featureFlags?.[flagName];
};
